import React, { useCallback, useEffect, useState } from 'react';
import Loader from 'react-loader-spinner';
import { useLocation, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import axios from 'supports/api';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import LivestreamSessionModal from './LivestreamSessionModal';
import './style.css';

const LivestreamSessionListPage = () => {
  const location = useLocation();

  const { programLivestreamModuleId } = useParams();

  const [loading, setLoading] = useState(false);
  const [livestreamModuleData, setLivestreamModuleData] = useState({});
  const [livestreamSessionList, setLivestreamSessionList] = useState([]);
  const [selectedLivestreamSession, setSelectedLivestreamSession] = useState(
    {},
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchSessionData = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `/v2/program-livestream/module/${programLivestreamModuleId}`,
      );
      const { programLivestreamSessions } = data?.data;
      setLivestreamModuleData(data.data);
      setLivestreamSessionList(programLivestreamSessions);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
      alert(err);
    }
  }, [programLivestreamModuleId]);

  useEffect(() => {
    fetchSessionData();
  }, [fetchSessionData]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const deleteLivestreamSession = async (id) => {
    if (window.confirm('Are you sure delete this session ?')) {
      try {
        await axios.delete(`/v2/program-livestream/session/${id}`);
        fetchSessionData();
      } catch (err) {
        alert(`Terjadi kesalahan pada system. ${err}`);
        console.log(err);
      }
    }
  };

  const LivestreamSessionList = () => {
    if (livestreamSessionList.length) {
      return livestreamSessionList.map((session) => {
        const { id, title, description, order, materials } = session;
        return (
          <div
            key={id}
            className="d-flex flex-row my-3 py-2 border justify-content-between"
            style={{ borderRadius: '6px' }}
          >
            <div className="col-10">
              <div className="row">
                <div className="col-3">Module Title</div>
                <div className="col-9">: {title}</div>
              </div>
              <div className="row">
                <div className="col-3">Description</div>
                <div className="col-9 livestream-session-description">
                  <span>: </span>
                  <span className="livestream-session-description">
                    <CKEditor editor={Editor} data={description} disabled />
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-3">Order</div>
                <div className="col-9">: {order}</div>
              </div>
              <div className="row">
                <div className="col-3">Total Material</div>
                <div className="col-9">: {materials.length}</div>
              </div>
            </div>
            <div className="col-2">
              <Button
                color="primary"
                className="mb-1 w-100"
                size="sm"
                onClick={() => {
                  setSelectedLivestreamSession(session);
                  toggleModal();
                }}
              >
                Details
              </Button>
              <Link to={`${location.pathname}/${id}/material`}>
                <Button
                  color="success"
                  size="sm"
                  className="w-100 font-weight-bold mb-1"
                >
                  Materials
                </Button>
              </Link>
              <Button
                color="danger"
                className="w-100 font-weight-bold"
                size="sm"
                onClick={() => deleteLivestreamSession(id)}
              >
                Delete
              </Button>
            </div>
          </div>
        );
      });
    }
    return (
      <div className="d-flex justify-content-center pt-5">
        <h4>NO DATA AVAILABLE</h4>
      </div>
    );
  };

  return (
    <div>
      <div
        className="white-box container py-2"
        style={{ minHeight: '100vh', marginTop: '40px' }}
      >
        <div className="mt-2">
          <Link
            to={`${location?.pathname.slice(
              0,
              location?.pathname.lastIndexOf(`/${programLivestreamModuleId}`),
            )}`}
            className="mt-auto"
          >
            <Button color="danger">{'<'} Back</Button>
          </Link>
        </div>
        <div className="d-flex flex-row justify-content-between mt-4 mb-5">
          <div
            className="font-weight-bold"
            style={{ fontSize: '26px', color: '#505050' }}
          >
            {livestreamModuleData.title} - Session Data
          </div>
          <Button
            className="float-right mt-auto"
            onClick={() => {
              toggleModal();
              setSelectedLivestreamSession({});
            }}
          >
            + Create Session
          </Button>
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center"
            style={{ minHeight: '100vh' }}
          >
            <Loader type="ThreeDots" color="black" />
          </div>
        ) : (
          <LivestreamSessionList />
        )}
      </div>
      <LivestreamSessionModal
        toggle={toggleModal}
        isModalOpen={isModalOpen}
        programLivestreamModuleId={programLivestreamModuleId}
        selectedLivestreamSession={selectedLivestreamSession}
        programLivestreamSessionLength={livestreamSessionList.length}
        refresh={fetchSessionData}
      />
    </div>
  );
};

export default LivestreamSessionListPage;
